// API base URL config for Amplify/EC2 or local
// const EC2_API_URL =  process.env.REACT_APP_API_URL ||"https://54.179.48.42";
const EC2_API_URL = process.env.REACT_APP_API_URL || "https://trade-api.serpx.net";
// const EC2_API_URL = process.env.REACT_APP_API_URL || "https://by-bit-backend.onrender.com";


//  const EC2_API_URL =  "http://localhost:80"; // Local development URL

// const EC2_API_URL =  "http://3.1.159.47:5000";

export const BASE_URL = EC2_API_URL;



// Example usage:
// fetch(`${BASE_URL}/api/orders`, fetchConfig)
